// src/contexts/ToastContext.js

import React, { createContext, useContext, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = "info", duration = 3000) => {
    setToast({ message, type });

    setTimeout(() => {
      setToast(null);
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast Container */}
      <div
        className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[5000] pointer-events-none"
        style={{ pointerEvents: "none" }}
      >
        <AnimatePresence>
          {toast && (
            <motion.div
              key="toast"
              initial={{ y: -40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -40, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className={`
                px-6 py-3 rounded-xl shadow-xl backdrop-blur-xl
                flex items-center gap-3 min-w-[260px] text-sm font-medium pointer-events-auto
                ${
                  toast.type === "error"
                    ? "bg-red-100 text-red-700 border border-red-200"
                    : toast.type === "success"
                    ? "bg-green-100 text-green-700 border border-green-200"
                    : "bg-gray-100 text-gray-700 border border-gray-200"
                }
              `}
            >
              {/* Icons */}
              {toast.type === "error" && (
                <span className="text-red-600 text-lg">⚠️</span>
              )}
              {toast.type === "success" && (
                <span className="text-green-600 text-lg">✔️</span>
              )}
              {toast.type === "info" && (
                <span className="text-gray-600 text-lg">ℹ️</span>
              )}

              <span>{toast.message}</span>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>
  );
}